import React from 'react';
import { Button, LinkButton } from '@domain-group/fe-blueprint-ui/button';
import { Tooltip } from '@domain-group/fe-blueprint-ui/tooltip';
import * as styles from './privacy-policy.style';

export interface PrivacyPolicyProps {
  // Tighter typography/spacing for enquiry-modal-2026, which already
  // controls its own vertical rhythm - the legacy enquiry-form default
  // (caption + 36px top margin) is unaffected.
  compact?: boolean;
}

const privacyNoticeUrl = 'https://www.costar.com/about/privacy-notice';

const PrivacyPolicy = ({
  compact = false,
}: PrivacyPolicyProps): JSX.Element => (
  <div
    css={compact ? styles.enquiryFormPrivacyCompact : styles.enquiryFormPrivacy}
  >
    By submitting your enquiry, you agree to our{' '}
    <LinkButton
      appearance="link"
      css={compact ? styles.privacyLinkCompact : styles.privacyLink}
      href={privacyNoticeUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </LinkButton>
    .{' '}
    <Tooltip
      content={
        <p>
          We collect personal data such as your contact and demographic
          information to share with our partners (such as this specific real
          estate agent and other relevant service providers) &amp; providing
          personalised content. For full details please refer to our&nbsp;
          <LinkButton
            appearance="link"
            href={privacyNoticeUrl}
            css={
              compact ? styles.privacyLinkModalCompact : styles.privacyLinkModal
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy.
          </LinkButton>
        </p>
      }
      placement="bottom"
      trigger="click"
      layer="layerModal"
    >
      <Button
        appearance="link"
        css={
          compact
            ? styles.enquiryFormMoreInfoCompact
            : styles.enquiryFormMoreInfo
        }
      >
        Click here for more information
      </Button>
    </Tooltip>
    .
  </div>
);

export default PrivacyPolicy;
